import { User } from '@/models/user';
import apiClient from '@/api/client';

export const InternalUserService = {
    async getAll(): Promise<InternalUserResponse> {
        const response = await apiClient.get<InternalUserResponse>('/internal/users');
        const result = response.data

        if (!result) {
            throw new Error('Failed to retrieve users.');
        }

        return result;
      },

    async create(firstName: string, lastName: string, email: string, role: string) {
        await apiClient.post('/internal/users', {
            firstName: firstName,
            lastName: lastName,
            email: email,
            role: role
        });
      },

    
    async update(id: string, firstName: string, lastName: string, email: string, role: string) {
        await apiClient.put(`/internal/users/${id}`, {
            firstName: firstName,
            lastName: lastName,
            email: email,
            role: role
        });
      },

    async delete(id: string) {
        await apiClient.delete(`/internal/users/${id}`);
      }
}

export interface InternalUserResponse {
    users: User[]
}